import { WarehouseloadComponent } from './warehouseload.component';

export const WAREHOUSELOAD_DECLARATIONS: any[] = [WarehouseloadComponent];